var modules_fe7e3e93 = {"wrapper":"OfferParams_module_wrapper__042020f4"};
import "../../../../assets/esm/components/OfferCard/components/OfferParams/OfferParams~B2HoAR55.css";

export { modules_fe7e3e93 as default };
//# sourceMappingURL=OfferParams.module.scss.js.map
